'use client'

import Link from 'next/link'

import { Button } from '@dc-shared-web/components/shadcn/button'

export default function ErrorMessage({
  message = 'The page could not be loaded.',
  refreshText = 'Try again',
  supportEmail = 'support@documentcrunch.com',
}: {
  message?: string
  refreshText?: string
  supportEmail?: string
}) {
  return (
    <div className='tw-text-neutral-400 tw-text-center tw-translate-y-[150%]'>
      <div className='tw-text-2xl tw-font-normal'>
        Oops! Something went wrong
      </div>
      <p className='tw-my-3'>{message}</p>
      <Button className='tw-w-40' onClick={() => window.location.reload()}>
        {refreshText}
      </Button>
      <p className='tw-mt-6 tw-text-sm tw-text-neutral-300'>
        If the issue persists, please contact support at{' '}
        <Link href={`mailto:${supportEmail}`} className='tw-underline'>
          {supportEmail}
        </Link>
      </p>
    </div>
  )
}
